// import React from "react";

// const PDFViewerIframe = ({ url }) => {
//   console.log(url);
//   return (
//     <div style={{ padding: "0px 10px" }}>
//       <iframe src={url} width="100%" height="450px" title="PDF Viewer" />

//     </div>
//   );
// };

// export default PDFViewerIframe;

import * as React from "react";
import { Viewer } from "@react-pdf-viewer/core";

import "@react-pdf-viewer/core/lib/styles/index.css";

const PDFViewerIframeEsign = ({ urldata }) => {
  return (
    <div style={{ height: "100%" }}>
      <iframe src={urldata} width="99%" height="100%" title="PDF Viewer" />
    </div>
  );
};

export default PDFViewerIframeEsign;
